import { render, staticRenderFns } from "./SMSTemplate.vue?vue&type=template&id=d94e27e8&"
import script from "./SMSTemplate.vue?vue&type=script&lang=js&"
export * from "./SMSTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SMSTemplate.vue?vue&type=style&index=0&id=d94e27e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports